<template>
    <div>
        <div class="row mb-3">
            <date-range-picker v-model="dateRange" :ranges="ranges" format="DD-MM-YYYY" @ok="handleSubmit"></date-range-picker>
        </div>

        <!-- Display added items -->
        <div class="row mb-3" v-for="(item, index) in items" :key="index">
            <div class="col-6">
                <label for="start-time">Start Time:</label>
                <input type="time" id="start-time" class="form-control" v-model="item.startTime" placeholder="08:00" />
            </div>
            <div class="col-6">
                <label for="end-time">End Time:</label>
                <input type="time" id="end-time" class="form-control" v-model="item.endTime" />
            </div>
            <div class="col-3">
                <input type="number" class="form-control" v-model="item.price" placeholder="Price" />
            </div>
            <div class="col-3">
                <input type="number" class="form-control" v-model="item.priceHT" placeholder="Price HT" />
            </div>
            <div class="col-3">
                <input type="number" class="form-control" v-model="item.vatRate" placeholder="VAT Percent" />
            </div>
            <div class="col-2">
                <button type="button" class="btn btn-danger btn-sm" @click="deleteItem(index)">Delete</button>
            </div>
        </div>

        <!-- Button to add a new item row -->
        <button type="button" class="btn btn-primary" @click="addItem">Add Item</button>

        <button type="button" class="btn btn-primary" @click="handleSubmit">Submit</button>
    </div>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import { BModal } from 'bootstrap-vue'
import axios from 'axios'

export default {
    props: {
        prestationId: {
            required: true,
        },
        showModal: {
            required: true,
        },
        selectedSlot: {
            required: true,
        },
    },
    data() {
        return {
            // showModal: false,
            selectedEvent: {},

            items: {
                start: '',
                end: '',
                price: '',
                priceHT: '',
                pricePercent: '',
            },
            items: [],
            dateRange: {
                startDate: null,
                endDate: null,
            },
            ranges: {
                Today: [new Date(), new Date()],
                Yesterday: [
                    new Date(new Date().setDate(new Date().getDate() - 1)),
                    new Date(new Date().setDate(new Date().getDate() - 1)),
                ],
                '+ 7 Days': [new Date(new Date().setDate(new Date().getDate() + 6)), new Date()],
                '+ 30 Days': [new Date(new Date().setDate(new Date().getDate() + 29)), new Date()],
                'This Month': [
                    new Date(new Date().getFullYear(), new Date().getMonth(), 1),
                    new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
                ],
                'Next Month': [
                    new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1),
                    new Date(new Date().getFullYear(), new Date().getMonth() + 2, 0),
                ],
            },
        }
    },

    watch: {
        // showModal(newVal) {
        //     if (newVal) {
        //         console.log('newVal', newVal)
        //         this.addItem()
        //     }
        // },
    },

    methods: {
        showEventDetails(event) {
            //  console.log('event', event)
            this.selectedEvent = event
            this.showModal = true
        },

        pushItems(planningPrices) {
            for (let index = 0; index < planningPrices.length; index++) {
                const [hoursStart, minutesStart] = planningPrices[index].start_time.split(':').slice(0, 2)
                const [hoursEnd, minutesEnd] = planningPrices[index].end_time.split(':').slice(0, 2)

                this.items.push({
                    startTime: `${hoursStart}:${minutesStart}`,
                    endTime: `${hoursEnd}:${minutesEnd}`,
                    price: planningPrices[index].price,
                    priceHT: planningPrices[index].price_ht,
                    vatRate: planningPrices[index].vat_rate,
                })
            }
        },

        addItem() {
            this.items.push({
                startTime: '',
                endTime: '',
                price: '',
                priceHT: '',
                vatRate: '',
            })
            //  console.log('this.items', this.items)
        },

        deleteItem(index) {
            // Remove the item from the items array based on index
            this.items.splice(index, 1)
        },

        isItemValid(item) {
            for (let key in item) {
                if (!item[key]) {
                    return false // If any field is null or empty, return false
                }
            }
            return true // If all fields are not null or empty, return true
        },

        resetDate(data) {
            // console.log('resetDate data start', data.start)
            // console.log('resetDate data end', data.end)

            this.dateRange.startDate = new Date(data.start).toISOString().split('T')[0] ?? null

            if (data.end === null) {
                const startDate = new Date(data.start)
                this.dateRange.endDate = new Date(startDate.setDate(startDate.getDate() + 1)).toISOString().split('T')[0]
            } else {
                this.dateRange.endDate = new Date(data.end).toISOString().split('T')[0] ?? null
            }
        },

        handleSubmit() {
            let verifedItems = this.items

            const payload = {
                range: this.dateRange,
                items: verifedItems.filter((item) => this.isItemValid(item)),
            }

            this.submit(this.prestationId, 1, payload)
        },

        async submit(prestationId, establishmentId, payload) {
            axios
                .post(`/back-office/prestation/${prestationId}/planning/${establishmentId}`, payload)
                .then(function (response) {
                    //console.log(response)
                })
                .catch(function (error) {
                    //console.log(error)
                })
        },
    },

    mounted() {
        // console.log('mounted')
        // console.log('Selected Slot:', this.selectedSlot)

        if (this.selectedSlot?.extendedProps?.planningPrices) {
            // console.log('start 1')
            this.resetDate(this.selectedSlot)
            this.pushItems(this.selectedSlot.extendedProps.planningPrices)
        } else {
            //  console.log('start 2')
            this.addItem()
            this.resetDate(this.selectedSlot)
        }
    },

    components: {
        BModal,
        DateRangePicker,
    },
}
</script>
